import { SELECTABLE_CONNECTIONS } from "../connection";
import { detectImTokenApp } from "../utils/userAgent";
import { useBreakpoint } from "./useMediaQuery";
export var useConnectionOptions = function useConnectionOptions() {
  var breakpoints = useBreakpoint();
  var isMobile = breakpoints.isMobile;
  var isImTokenApp = detectImTokenApp();
  var isDesktop = !isMobile && !isImTokenApp;
  var options = SELECTABLE_CONNECTIONS.filter(function (connection) {
    if (typeof connection.shouldDisplay === 'function') {
      return connection.shouldDisplay(breakpoints, {
        isImTokenApp: isImTokenApp,
        isDesktop: isDesktop
      });
    }
  });
  return options;
};